<template>
  <ImageGalleryForPc 
    v-if="!isMobile"
    :imageItems="imageItems"
    :imageHeightClass="imageHeightClass"
    :columns="columns"
    :imagesPerPage="imagesPerPage"
  />
  
  <ImageGalleryForMobile 
    v-else
    :imageItems="imageItems"
    :imagesPerPage="imagesPerPage || 8"
    :columns="2"
  />
</template>

<script setup lang="ts">
import { useDeviceDetection } from '@/utils/deviceDetection';
import ImageGalleryForPc from './ImageGalleryForPc.vue';
import ImageGalleryForMobile from './ImageGalleryForMobile.vue';

const { isMobile } = useDeviceDetection();

interface ImageItem {
  src: string;
  alt: string;
  caption: string;
}

defineProps<{
  imageItems: ImageItem[];
  imageHeightClass?: string;
  columns?: number;
  imagesPerPage?: number;
}>();
</script>
